<template>
  <article class="voice-panel__wrapper">
    <section class="segment"></section>
    <section class="title">{{ title }}</section>
    <section class="operate">
      <slot name="operate"></slot>
    </section>
  </article>
</template>

<script>
export default {
  name: 'VoicePanel',
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-panel__wrapper {
  padding-top: 44px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  .segment {
    width: 6px;
    height: 24px;
    background: #FA2900;
    border-radius: 3px;
  }
  .title {
    margin-left: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #000000;
  }
  .operate {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>